import { addParamURL, removeAllParamsURL } from './';

export const replaceParamsURL = (parameterName: string, parameter: string) => {
  removeAllParamsURL();
  addParamURL(parameterName, parameter);
};
